import { render, staticRenderFns } from "./KLAImpressao.vue?vue&type=template&id=a6c1248a&scoped=true"
import script from "./KLAImpressao.vue?vue&type=script&lang=js"
export * from "./KLAImpressao.vue?vue&type=script&lang=js"
import style0 from "./KLAImpressao.vue?vue&type=style&index=0&id=a6c1248a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c1248a",
  null
  
)

export default component.exports